// extracted by mini-css-extract-plugin
module.exports = {"menuIcon":"style_menuIcon__3RZg3","container":"style_container__3GMtP","buttons":"style_buttons__BAKnh"};